const React = require('react');
const {
  LINK_ADMIN_LOGS_ITEM,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  Link,
} = require('../../../../router');
const {
  apiAdminStatusRestart,
} = require('../../../../api/admin/status');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const CheckboxA = require('../../../dumb/Checkbox/F');
const ButtonA = require('../../../dumb/Button/A');


module.exports = withState((setState, self) => {
  return (state, props) => {
    const data = props.data || {};
    const id = data.id;
    return (
      <div className="layoutRow fhaS fvaC">
        <div className="w(|min)380">
          <CheckboxA
            checked={data.checked}
            label={(
              <Link
                className="cCT tdN olN"
                href={LINK_ADMIN_LOGS_ITEM + id}
              >{data.name}</Link>
            )}
          />
        </div>
        {data.staticFiles ? (
          <div
            className="w100 layoutRow fhaC fvaC"
          >Static files</div>
        ) : (
          <WrapperWithLoading
            loading={state.loading}
          >
            <ButtonA
              className="w100"
              onClick={() => {
                setState({
                  loading: true,
                });
                apiAdminStatusRestart({
                  id,
                }).finally(() => {
                  setState({
                    loading: false,
                  });
                });
              }}
            >Restart</ButtonA>
          </WrapperWithLoading>
        )}
      </div>
    );
  };
});
